import React from 'react';
import { motion } from 'framer-motion';
import { WalletIcon, ShieldIcon, UsbIcon, HardDriveIcon } from 'lucide-react';
export function ProductsSection() {
  const products = [{
    icon: WalletIcon,
    title: 'Hardware Wallets & Signers',
    description: 'Secure cryptocurrency storage and transaction signing devices from leading manufacturers'
  }, {
    icon: ShieldIcon,
    title: 'Faraday Sleeves & Bags',
    description: 'Signal-blocking protection for devices against remote tracking and unauthorized access'
  }, {
    icon: UsbIcon,
    title: 'USB Data Blockers & Privacy Dongles',
    description: 'Charge-only adapters and privacy tools to prevent data theft and juice jacking'
  }, {
    icon: HardDriveIcon,
    title: 'FIPS & Secured Storage',
    description: 'Encrypted HDDs and SSDs meeting government-grade security standards'
  }];
  return <section id="products" className="py-20 px-6 relative overflow-hidden bg-white" data-id="element-224">
      {/* Background Image */}
      <div className="absolute inset-0 opacity-5" style={{
      backgroundImage: 'url(https://images.unsplash.com/photo-1558494949-ef010cbdcc31?w=1600&q=80)',
      backgroundSize: 'cover',
      backgroundPosition: 'center'
    }} data-id="element-225" />
      {/* Circuit Pattern Overlay */}
      <div className="absolute inset-0 opacity-5" style={{
      backgroundImage: 'url(https://images.unsplash.com/photo-1518770660439-4636190af475?w=1600&q=80)',
      backgroundSize: '400px',
      backgroundRepeat: 'repeat'
    }} data-id="element-226" />
      <div className="max-w-6xl mx-auto relative z-10" data-id="element-227">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-228">
          <h2 className="text-4xl font-bold text-[#0B1220] mb-4" data-id="element-229">
            What We Supply
          </h2>
          <p className="text-lg text-gray-600" data-id="element-230">
            Comprehensive electronic security solutions for enterprise needs
          </p>
        </motion.div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-231">
          {products.map((product, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-white/90 backdrop-blur-sm rounded-2xl p-8 border border-gray-100 hover:shadow-lg transition-all" data-id="element-232">
              <div className="w-14 h-14 bg-gradient-to-br from-[#3B82F6] to-[#10B981] rounded-xl flex items-center justify-center mb-6" data-id="element-233">
                <product.icon className="w-7 h-7 text-white" data-id="element-234" />
              </div>
              <h3 className="text-xl font-bold text-[#0B1220] mb-3" data-id="element-235">
                {product.title}
              </h3>
              <p className="text-gray-600 leading-relaxed" data-id="element-236">
                {product.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}